import { render, staticRenderFns } from "./ProgramInfosPrescriber.vue?vue&type=template&id=94d5fb84&scoped=true&"
import script from "./ProgramInfosPrescriber.vue?vue&type=script&lang=ts&"
export * from "./ProgramInfosPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramInfosPrescriber.vue?vue&type=style&index=0&id=94d5fb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d5fb84",
  null
  
)

export default component.exports